module.exports = __webpack_public_path__ + "bdef04d9.svg";